export class ChangepasswordModel {
   public userId: string;
   public oldPassword: string;
   public newPassword: string;
}

export class PasswordChangeModel extends ChangepasswordModel{
   
}
